import { ApiResponse } from 'common/domain/entities/api-response';
import { AddCataglogModel, CatelogBackofficeModel } from '../dto/catelog-backoffice-model';
import { CatelogApi, FilterParams } from './catelog-api';
import http from './http';
import { serializeFormQuery } from 'common/utils/general.utils';
import axios, { AxiosError } from 'axios';

export class CatelogApiImpl implements CatelogApi {
	apiService = http;

	async getCatelogs(params: FilterParams): Promise<ApiResponse<CatelogBackofficeModel[]>> {
		try {
			const query = serializeFormQuery(params);
			const resp = await this.apiService.get(`/catalogs${query}`);
			const data = resp.data as ApiResponse<CatelogBackofficeModel[]>;
			return Promise.resolve(data);
		} catch (err) {
			if (axios.isAxiosError(err)) {
				const errData = err as AxiosError;
				if (errData.response?.data) {
					const data = errData.response?.data as ApiResponse<void>;
					return Promise.reject(data);
				}
			}
			const error = { message: 'unexpected_error' } as ApiResponse<void>;
			return Promise.reject(error);
		}
	}

	async changeCatelogStatus(id: number, isActive: boolean): Promise<ApiResponse<void>> {
		try {
			const resp = await this.apiService.patch(`/catalogs/${id}/status?isActive=${isActive}`);
			const data = resp.data as ApiResponse<void>;
			return Promise.resolve(data);
		} catch (err) {
			if (axios.isAxiosError(err)) {
				const errData = err as AxiosError;
				if (errData.response?.data) {
					const data = errData.response?.data as ApiResponse<void>;
					return Promise.reject(data);
				}
			}
			const error = { message: 'unexpected_error' } as ApiResponse<void>;
			return Promise.reject(error);
		}
	}

	async getCatelogById(id: number): Promise<ApiResponse<CatelogBackofficeModel>> {
		try {
			const resp = await this.apiService.get(`/catalogs/${id}`);
			const data = resp.data as ApiResponse<CatelogBackofficeModel>;
			return Promise.resolve(data);
		} catch (err) {
			if (axios.isAxiosError(err)) {
				const errData = err as AxiosError;
				if (errData.response?.data) {
					const data = errData.response?.data as ApiResponse<void>;
					return Promise.reject(data);
				}
			}
			const error = { message: 'unexpected_error' } as ApiResponse<void>;
			return Promise.reject(error);
		}
	}

	async addCatelog(catelog: AddCataglogModel): Promise<ApiResponse<CatelogBackofficeModel>> {
		try {
			const resp = await this.apiService.post('/catalogs', catelog);
			const data = resp.data as ApiResponse<CatelogBackofficeModel>;
			return Promise.resolve(data);
		} catch (err) {
			if (axios.isAxiosError(err)) {
				const errData = err as AxiosError;
				if (errData.response?.data) {
					const data = errData.response?.data as ApiResponse<void>;
					return Promise.reject(data);
				}
			}
			const error = { message: 'unexpected_error' } as ApiResponse<void>;
			return Promise.reject(error);
		}
	}

	async updateCatelog(
		id: number,
		catelog: AddCataglogModel,
	): Promise<ApiResponse<CatelogBackofficeModel>> {
		try {
			const resp = await this.apiService.patch(`/catalogs/${id}`, catelog);
			const data = resp.data as ApiResponse<CatelogBackofficeModel>;
			return Promise.resolve(data);
		} catch (err) {
			if (axios.isAxiosError(err)) {
				const errData = err as AxiosError;
				if (errData.response?.data) {
					const data = errData.response?.data as ApiResponse<void>;
					return Promise.reject(data);
				}
			}
			const error = { message: 'unexpected_error' } as ApiResponse<void>;
			return Promise.reject(error);
		}
	}
}
